module.exports = __webpack_public_path__ + "img/Icon ionic-md-play-circle.90c051d2.svg";